import { Widget } from "@rjsf/core";
import { FormMessage, Select } from "@xometry/xometry_loft";

import { getEnumOptions } from "../utils";
import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { FullWidth, Section } from "./Shared.style";

export const LoftSelectField: Widget = ({
  onChange,
  onBlur,
  options,
  schema,
  required,
  rawErrors,
  value,
  disabled,
  uiSchema,
}) => {
  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);
  const enumOptions = getEnumOptions(schema, options);

  if (!enumOptions.find(option => option.value === "")) {
    enumOptions.unshift({ value: "", label: "" });
  }

  return (
    <div css={[Section, FullWidth]}>
      <LabelWithOptionalFlag
        required={required}
        tooltip={(options?.tooltip || "") as string}
      >
        {schema.title}
      </LabelWithOptionalFlag>
      <Select
        disabled={disabled}
        name={options?.name as string}
        defaultValue={value}
        invalid={isInvalid}
        onChange={e => {
          onChange(e.currentTarget.value || undefined);
        }}
        onBlur={e => {
          onBlur(e.currentTarget.name, e.currentTarget.value || null);
        }}
      >
        {enumOptions?.map((opt, idx) => {
          const { value, label } = opt;
          return (
            <option key={`${value}-${idx.toString()}`} value={value.toString()}>
              {label.toString()}
            </option>
          );
        })}
      </Select>
      {uiSchema?.description && (
        <FormMessage>{uiSchema.description}</FormMessage>
      )}
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
